import React from 'react'
import { store } from 'index'
import { convertToMillion, formatThousands } from 'utils/Utils'
import { connect } from 'react-redux'

class ExpandableRow extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			expand: false
		}

		this.onLoad = this.onLoad.bind(this)
		this.handleCollapseChange = this.handleCollapseChange.bind(this)
		this.handleSupplierDetailsClick =
			this.handleSupplierDetailsClick.bind(this)
	}

	onLoad() {
		const state = store.getState(),
			enablementWaveData = this.props.tabData

		const target = enablementWaveData[0]

		var collapsibleElement =
			document.getElementsByClassName("collapsible");

		let childCount, item, childTarget, content

		target.rows.map((data, index) => {
			if (data[0].collapseChild !== undefined) {
				childCount = data[0].collapseChild.length
				item = data[0].content

				let eleIndex, cntIndex

				for (
					eleIndex = 0;
					eleIndex < collapsibleElement.length;
					eleIndex++
				) {
					var childItem =
						collapsibleElement[eleIndex].firstChild.innerText;

					if (
						childItem &&
						childItem.toLowerCase() === item.toLowerCase()
					) {
						for (
							cntIndex = 0;
							cntIndex < childCount;
							cntIndex++
						) {
							if (cntIndex === 0) {
								content =
									collapsibleElement[eleIndex].nextSibling;
							}
							else {
								content =
									childTarget.nextSibling;
							}

							if (
								content &&
								content.style !== undefined
							) {
								content.style.visibility = 'collapse';
								childTarget = content
							}
						}
					}
				}
			}
		})
	}

	/*
	 * Handles the existing + / - expand collapse action.
	 *
	 * IMPORTANT:
	 * The popup click on the text stops propagation,
	 * so clicking the text does NOT trigger this method.
	 */
	handleCollapseChange(e) {
		e.stopPropagation();

		if (
			this.props.data &&
			Array.isArray(this.props.data.collapseChild) &&
			this.props.data.collapseChild.length > 0
		) {
			this.setState({
				expand: !this.state.expand
			});
		}
	}

	/*
	 * Handles popup click.
	 *
	 * Enablement Type L4 hierarchy:
	 *
	 * L1 = Enablement Wave
	 * L2 = Enablement Type
	 * L3 = Workstream
	 * L4 = L4 Industry / selected L4 value
	 *
	 * For L4:
	 * column1Value = Enablement Wave
	 * column2Value = Enablement Type
	 * column3Value = L4 value
	 */
	handleSupplierDetailsClick(e) {
		e.stopPropagation();
	  
		const data = this.props.data || {};
	  
		// const enablementTypeViews = [
		//   "enablementTypeL4",
		//   "enablementTypeISO",
		//   "enablementTypeDetails",
		//   "enablementTypeRecommendation"
		// ];
	  
		// const isEnablementTypeView =
		// enablementTypeViews.includes(this.props.selectedTableView);

		const isEnablementTypeView = this.props.tableName == "Enablement Strategy by Enablement Type with Onboarding Workstream";

	  
		/*
		 * Enablement Type - 4 level hierarchy
		 *
		 * Wave
		 *   -> Enablement Type
		 *      -> Workstream
		 *         -> L4 / Details
		 *
		 * For L4 click:
		 *   Column1 = Wave
		 *   Column2 = Enablement Type
		 *   Column3 = Workstream
		 *   Column4 = null
		 */
		if (
			isEnablementTypeView &&
			data.enablementWave !== undefined &&
			data.enablementType !== undefined &&
			data.thirdLevelValue !== undefined
		  ) {

			// console.log("🔴 L4 CLICK DATA:", {
			// 	selectedTableView: this.props.selectedTableView,
			
			// 	content: data.content,
			
			// 	enablementWave: data.enablementWave,
			
			// 	enablementType: data.enablementType,
			
			// 	secondLevelValue: data.secondLevelValue,
			
			// 	thirdLevelValue: data.thirdLevelValue,
			
			// 	parent: data.parent,
			
			// 	fullData: data
			// });

			this.props.showEnablementSupplierDetailsModal(
			  this.props.tableName,
			  this.props.columnDetails.firstColumn,
			  data.enablementWave,       // Column 1 = Wave
			  data.enablementType,       // Column 2 = Enablement Type
			  data.thirdLevelValue,      // Column 3 = Workstream
			  data.fourthLevelValue              // Column 4 = L4 value
			);
		  
			return;
		  }
	  
		/*
		 * Enablement Type - Workstream click
		 *
		 * For L3 click:
		 *   Column1 = Wave
		 *   Column2 = null
		 *   Column3 = Workstream
		 *   Column4 = null
		 */
		if (
		  isEnablementTypeView &&
		  data.enablementWave !== undefined &&
		  data.secondLevelValue !== undefined &&
		  data.thirdLevelValue === undefined
		) {
			//console.log("🔴 L3 CLICK DATA:");
		  this.props.showEnablementSupplierDetailsModal(
			this.props.tableName,
			this.props.columnDetails.firstColumn,
			data.enablementWave,       // Column 1 Value
			data.secondLevelValue,                     // Column 2 Value = NULL
			data.content,              // Column 3 Value = Workstream
			null                       // Column 4 Value = NULL
		  );
	  
		  return;
		}
	  
		/*
		 * Existing handling for all other views
		 */
		this.props.showEnablementSupplierDetailsModal(
		  this.props.tableName,
		  this.props.columnDetails.firstColumn,
		  this.props.parentColumnValue,
		  (
			this.props.tabName === this.props.content.enablementTabName &&
			!this.props.fromGanntChart
		  )
			? this.props.secondParentColumnValue
			: this.props.fromGanntChart
			  ? this.props.columnDetails.secondColumn
			  : data.content,
		  (
			this.props.tabName === this.props.content.enablementTabName ||
			this.props.fromGanntChart
		  )
			? data.content
			: null
		);
	  }

	render() {

		const data = this.props.data || {};
		const rowData = data.data || {};

		const hasChildren =
			Array.isArray(data.collapseChild) &&
			data.collapseChild.length > 0;

		return (
			<React.Fragment>

				{/* =====================================================
				    CURRENT ROW
				    ===================================================== */}

				<tr
					className={
						hasChildren
							? `contentVisible collapsible${this.state.expand ? ' active' : ''}`
							: 'contentVisible'
					}
					onClick={
						hasChildren
							? this.handleCollapseChange
							: undefined
					}
				>

					{
						this.props.tabName ===
							this.props.content.onboardingWSTabName ||
						this.props.tabName ===
							this.props.content.enablementRecomTabName
							? (
								<td
									className="tableContent column-align-right"
									width="10%"
								></td>
							)
							: null
					}


					{/* =====================================================
					    FIRST COLUMN

					    + / - click:
					        -> handleCollapseChange()
					        -> expand / collapse

					    Text click:
					        -> handleSupplierDetailsClick()
					        -> popup

					    stopPropagation() ensures that clicking the
					    text never triggers expand/collapse.
					    ===================================================== */}

{(() => {
    const TOGGLE_WIDTH = 22;
    const LEAF_INDENT = 18;

    return (
        <td
            className="tableContent onMouseOver"
            style={{
                cursor: 'pointer',
                position: 'relative'
                // ❌ removed overflow: 'hidden' — it was clipping the '+' pseudo-element
            }}
            width="25%"
        >
            <span
                style={{
                    cursor: 'pointer',
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    right: 0,

                    left: hasChildren ? TOGGLE_WIDTH : 0,
                    paddingLeft: hasChildren
                        ? 0
                        : TOGGLE_WIDTH + LEAF_INDENT,

                    display: 'flex',
                    alignItems: 'center',
                    paddingRight: 8,
                    boxSizing: 'border-box',

                    // These stay — they clip/ellipsize the span's own text,
                    // not the td's pseudo-element.
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}
                onClick={this.handleSupplierDetailsClick}
                title={data.content ? data.content : ''}
            >
                {data.content === '*' ||
                 data.content === null ||
                 data.content === undefined ||
                 data.content === ''
                    ? '\u00A0'
                    : data.content}
            </span>
        </td>
    );
})()}
					{
						this.props.tabName ===
							this.props.content.enablementTabName &&
						!this.props.fromGanntChart
							? (
								<td></td>
							)
							: null
					}


					{/* =====================================================
					    CNT_VENDOR_NAME
					    ===================================================== */}

					<td
						className="tableContent column-align-right"
						width="10%"
					>
						{
							rowData.CNT_VENDOR_NAME !== undefined
								? formatThousands(
									rowData.CNT_VENDOR_NAME
								)
								: null
						}
					</td>


					{/* =====================================================
					    CNT_VENDOR_PER
					    ===================================================== */}

					<td
						className="tableContent column-align-right"
						width="10%"
					>
						{
							rowData.CNT_VENDOR_PER !== undefined
								? Number(
									rowData.CNT_VENDOR_PER
								).toFixed(2) + "%"
								: null
						}
					</td>


					{/* =====================================================
					    CNT_UNIQ_VENDOR_AN_ID
					    ===================================================== */}

					{
						this.props.tableName ===
							this.props.content.networkMatch.catalogMatchHeader ||
						this.props.tableName ===
							this.props.content.networkMatch.integrationMatchHeader
							? (
								<td
									className="tableContent column-align-right"
									width="10%"
								>
									{
										rowData.CNT_UNIQ_VENDOR_AN_ID !==
										undefined
											? formatThousands(
												rowData.CNT_UNIQ_VENDOR_AN_ID
											)
											: null
									}
								</td>
							)
							: null
					}


					{/* =====================================================
					    SUM_AGGR_SPEND
					    ===================================================== */}

					<td
						className="tableContent column-align-right"
						width="10%"
					>
						{
							rowData.SUM_AGGR_SPEND !== undefined
								? this.props.currencySymbol +
								convertToMillion(
									rowData.SUM_AGGR_SPEND,
									true
								)
								: null
						}
					</td>


					{/* =====================================================
					    SUM_AGGR_SPEND_PER
					    ===================================================== */}

					<td
						className="tableContent column-align-right"
						width="10%"
					>
						{
							rowData.SUM_AGGR_SPEND_PER !== undefined
								? Number(
									rowData.SUM_AGGR_SPEND_PER
								).toFixed(2) + "%"
								: null
						}
					</td>


					{/* =====================================================
					    SUM_SAP_ARIBA_DOC_PROXY
					    ===================================================== */}

					<td
						className="tableContent column-align-right"
						width="10%"
					>
						{
							rowData.SUM_SAP_ARIBA_DOC_PROXY !== undefined
								? formatThousands(
									rowData.SUM_SAP_ARIBA_DOC_PROXY
								)
								: null
						}
					</td>


					{/* =====================================================
					    SAP_ARIBA_DOC_PROXY_PER
					    ===================================================== */}

					<td
						className="tableContent column-align-right"
						width="10%"
					>
						{
							rowData.SAP_ARIBA_DOC_PROXY_PER !== undefined
								? Number(
									rowData.SAP_ARIBA_DOC_PROXY_PER
								).toFixed(2) + "%"
								: null
						}
					</td>

				</tr>


				{/* =====================================================
				    CHILD ROWS

				    L1
				        -> L2

				    L2
				        -> L3

				    L3
				        -> L4

				    L4
				        -> no children

				    ===================================================== */}

				{
					hasChildren &&
					this.state.expand
						? data.collapseChild.map(
							(child, index) => {

								return (
									<ExpandableRow
										key={
											child.childContentId !==
											undefined
												? child.childContentId
												: index
										}

										data={child}

										showEnablementSupplierDetailsModal={
											this.props
												.showEnablementSupplierDetailsModal
										}

										columnDetails={
											this.props.columnDetails
										}

										parentColumnValue={
											data.content
										}

										secondParentColumnValue={
											this.props
												.secondParentColumnValue
										}

										tableName={
											this.props.tableName
										}

										tabName={
											this.props.tabName
										}

										metricsType={
											this.props.metricsType
										}

										content={
											this.props.content
										}

										fromGanntChart={
											this.props.fromGanntChart
										}

										currencySymbol={
											this.props.currencySymbol
										}
										//selectedTableView={this.props.selectedTableView}
									/>
								);
							}
						)
						: null
				}

			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		content: state.content.enablementInsight,
	}
}

export default connect(mapStateToProps)(ExpandableRow)